var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlgorandwallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 20,
    fill: "#1CAD98"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2480_670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2989 53L27.5237 43.9841L32.7485 35L37.9414 25.9841L38.8016 24.5556L39.1839 25.9841L40.7768 31.9206L38.9927 35L33.768 43.9841L28.575 53H34.8193L40.0441 43.9841L42.752 39.3175L44.0264 43.9841L46.4476 53H52.0547L49.6335 43.9841L47.2122 35L46.575 32.6825L50.4618 25.9841H44.791L44.5998 25.3175L42.6246 17.9524L42.3697 17H36.9219L36.7945 17.1905L31.6972 25.9841L26.4724 35L21.2795 43.9841L16.0547 53H22.2989Z",
    fill: "#18A28E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2442 53L26.469 43.9841L31.6938 35L36.8867 25.9841L37.7469 24.5556L38.1292 25.9841L39.7221 31.9206L37.9381 35L32.7133 43.9841L27.5204 53H33.7646L38.9894 43.9841L41.6973 39.3175L42.9717 43.9841L45.3929 53H51L48.5788 43.9841L46.1575 35L45.5204 32.6825L49.4071 25.9841H43.7363L43.5451 25.3175L41.5699 17.9524L41.315 17H35.8673L35.7398 17.1905L30.6425 25.9841L25.4177 35L20.2248 43.9841L15 53H21.2442Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2480_670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorandwallet);
export default __webpack_public_path__ + "static/media/algorandwallet.12865fcf18992e4f3b80e323a7dbda59.svg";
export { ForwardRef as ReactComponent };